/* tslint:disable */
/* eslint-disable */
/**
 * Bots API
 * API for bots service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * * `RichTextBlock` - RichTextBlock
 * @export
 * @enum {string}
 */

export const BlockTypeEnum = {
    RichTextBlock: 'RichTextBlock'
} as const;

export type BlockTypeEnum = typeof BlockTypeEnum[keyof typeof BlockTypeEnum];


/**
 * * `daily` - Daily (one point per day) * `intraday` - Intraday (one point per N minutes)
 * @export
 * @enum {string}
 */

export const ChartModeEnum = {
    Daily: 'daily',
    Intraday: 'intraday'
} as const;

export type ChartModeEnum = typeof ChartModeEnum[keyof typeof ChartModeEnum];


/**
 * Child page summary for navigation.
 * @export
 * @interface ChildPage
 */
export interface ChildPage {
    /**
     * 
     * @type {string}
     * @memberof ChildPage
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof ChildPage
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ChildPage
     */
    'url_path': string;
    /**
     * 
     * @type {PageTypeEnum}
     * @memberof ChildPage
     */
    'page_type': PageTypeEnum;
    /**
     * Optional featured image
     * @type {Image}
     * @memberof ChildPage
     */
    'featured_image': Image | null;
    /**
     * 
     * @type {string}
     * @memberof ChildPage
     */
    'first_published_at': string | null;
}


/**
 * Read serializer — includes annotated counts and per-user upvote state.
 * @export
 * @interface Comment
 */
export interface Comment {
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'thread_id': string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'parent': string | null;
    /**
     * 
     * @type {number}
     * @memberof Comment
     */
    'author': number;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'author_name': string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'body_display': string;
    /**
     * 
     * @type {boolean}
     * @memberof Comment
     */
    'is_edited': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Comment
     */
    'is_deleted': boolean;
    /**
     * 
     * @type {number}
     * @memberof Comment
     */
    'upvote_count': number;
    /**
     * 
     * @type {number}
     * @memberof Comment
     */
    'reply_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof Comment
     */
    'has_upvoted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'updated_at': string;
}
/**
 * Write serializer for creating a new comment.
 * @export
 * @interface CommentCreate
 */
export interface CommentCreate {
    /**
     * 
     * @type {string}
     * @memberof CommentCreate
     */
    'thread_id': string;
    /**
     * 
     * @type {string}
     * @memberof CommentCreate
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof CommentCreate
     */
    'parent'?: string | null;
}
/**
 * Write serializer for editing a comment body.
 * @export
 * @interface CommentUpdate
 */
export interface CommentUpdate {
    /**
     * 
     * @type {string}
     * @memberof CommentUpdate
     */
    'body': string;
}
/**
 * StreamField block with type info derived from Wagtail block classes.
 * @export
 * @interface ContentBlock
 */
export interface ContentBlock {
    /**
     * Block name as defined in StreamField
     * @type {string}
     * @memberof ContentBlock
     */
    'name': string;
    /**
     * Wagtail block class type  * `RichTextBlock` - RichTextBlock
     * @type {BlockTypeEnum}
     * @memberof ContentBlock
     */
    'block_type': BlockTypeEnum;
    /**
     * Block value (shape depends on block_type)
     * @type {any}
     * @memberof ContentBlock
     */
    'value': any;
}


/**
 * 
 * @export
 * @interface HealthCheck
 */
export interface HealthCheck {
    /**
     * 
     * @type {string}
     * @memberof HealthCheck
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof HealthCheck
     */
    'database': string;
}
/**
 * Wagtail image with URL and metadata.
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * Full URL to the image
     * @type {string}
     * @memberof Image
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'height': number;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'alt': string;
}
/**
 * Unified page serializer for any CMS page.
 * @export
 * @interface PageTree
 */
export interface PageTree {
    /**
     * 
     * @type {number}
     * @memberof PageTree
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PageTree
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof PageTree
     */
    'title': string;
    /**
     * 
     * @type {PageTypeEnum}
     * @memberof PageTree
     */
    'page_type': PageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PageTree
     */
    'url_path': string;
    /**
     * Optional featured image
     * @type {Image}
     * @memberof PageTree
     */
    'featured_image': Image | null;
    /**
     * 
     * @type {Array<ContentBlock>}
     * @memberof PageTree
     */
    'body': Array<ContentBlock>;
    /**
     * 
     * @type {string}
     * @memberof PageTree
     */
    'seo_title': string;
    /**
     *
     * @type {string}
     * @memberof PageTree
     */
    'search_description': string;
    /**
     * OG image (falls back to featured_image)
     * @type {Image}
     * @memberof PageTree
     */
    'og_image': Image | null;
    /**
     *
     * @type {string}
     * @memberof PageTree
     */
    'first_published_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof PageTree
     */
    'last_published_at': string | null;
    /**
     * 
     * @type {Array<ChildPage>}
     * @memberof PageTree
     */
    'children': Array<ChildPage>;
}


/**
 * * `blog_post` - Blog Post * `flexible` - Flexible
 * @export
 * @enum {string}
 */

export const PageTypeEnum = {
    BlogPost: 'blog_post',
    Flexible: 'flexible'
} as const;

export type PageTypeEnum = typeof PageTypeEnum[keyof typeof PageTypeEnum];


/**
 * Write serializer for editing a comment body.
 * @export
 * @interface PatchedCommentUpdate
 */
export interface PatchedCommentUpdate {
    /**
     * 
     * @type {string}
     * @memberof PatchedCommentUpdate
     */
    'body'?: string;
}
/**
 * Serializer for updating pools (superadmin only).
 * @export
 * @interface PatchedPoolUpdate
 */
export interface PatchedPoolUpdate {
    /**
     * 
     * @type {string}
     * @memberof PatchedPoolUpdate
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPoolUpdate
     */
    'description'?: string;
    /**
     * Betting automatically closes at this time (optional - leave empty for manual close only)
     * @type {string}
     * @memberof PatchedPoolUpdate
     */
    'expiry_datetime'?: string | null;
}
/**
 * Serializer for creating pools (superadmin only).
 * @export
 * @interface PoolCreate
 */
export interface PoolCreate {
    /**
     * 
     * @type {string}
     * @memberof PoolCreate
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PoolCreate
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof PoolCreate
     */
    'description'?: string;
    /**
     * List of valid betting options, e.g., [\'boy\', \'girl\']
     * @type {any}
     * @memberof PoolCreate
     */
    'options'?: any;
    /**
     * Betting automatically closes at this time (optional - leave empty for manual close only)
     * @type {string}
     * @memberof PoolCreate
     */
    'expiry_datetime'?: string | null;
}
/**
 * Serializer for pool detail view with additional fields.
 * @export
 * @interface PoolDetail
 */
export interface PoolDetail {
    /**
     * 
     * @type {string}
     * @memberof PoolDetail
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PoolDetail
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof PoolDetail
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PoolDetail
     */
    'description'?: string;
    /**
     * List of valid betting options, e.g., [\'boy\', \'girl\']
     * @type {any}
     * @memberof PoolDetail
     */
    'options'?: any;
    /**
     * 
     * @type {StatusEnum}
     * @memberof PoolDetail
     */
    'status'?: StatusEnum;
    /**
     * Betting automatically closes at this time (optional - leave empty for manual close only)
     * @type {string}
     * @memberof PoolDetail
     */
    'expiry_datetime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PoolDetail
     */
    'is_betting_open': boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PoolDetail
     */
    'vote_counts': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof PoolDetail
     */
    'result'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolDetail
     */
    'revealed_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolDetail
     */
    'created_by_email': string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolDetail
     */
    'created_at': string;
    /**
     * 
     * @type {ChartModeEnum}
     * @memberof PoolDetail
     */
    'chart_mode'?: ChartModeEnum;
    /**
     * Bucket size in minutes. Only used when chart_mode is \'intraday\'.
     * @type {number}
     * @memberof PoolDetail
     */
    'chart_interval_minutes'?: number;
    /**
     * 
     * @type {string}
     * @memberof PoolDetail
     */
    'my_vote': string | null;
    /**
     * 
     * @type {number}
     * @memberof PoolDetail
     */
    'total_votes': number;
}


/**
 * Serializer for pool list view.
 * @export
 * @interface PoolList
 */
export interface PoolList {
    /**
     * 
     * @type {string}
     * @memberof PoolList
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PoolList
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof PoolList
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PoolList
     */
    'description'?: string;
    /**
     * List of valid betting options, e.g., [\'boy\', \'girl\']
     * @type {any}
     * @memberof PoolList
     */
    'options'?: any;
    /**
     * 
     * @type {StatusEnum}
     * @memberof PoolList
     */
    'status'?: StatusEnum;
    /**
     * Betting automatically closes at this time (optional - leave empty for manual close only)
     * @type {string}
     * @memberof PoolList
     */
    'expiry_datetime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PoolList
     */
    'is_betting_open': boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PoolList
     */
    'vote_counts': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof PoolList
     */
    'result'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolList
     */
    'revealed_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolList
     */
    'created_by_email': string | null;
    /**
     * 
     * @type {string}
     * @memberof PoolList
     */
    'created_at': string;
    /**
     * 
     * @type {ChartModeEnum}
     * @memberof PoolList
     */
    'chart_mode'?: ChartModeEnum;
    /**
     * Bucket size in minutes. Only used when chart_mode is \'intraday\'.
     * @type {number}
     * @memberof PoolList
     */
    'chart_interval_minutes'?: number;
}


/**
 * Read-only snapshot of vote counts at a point in time.
 * @export
 * @interface PoolSnapshot
 */
export interface PoolSnapshot {
    /**
     * 
     * @type {number}
     * @memberof PoolSnapshot
     */
    'id': number;
    /**
     * Vote counts per option at this moment
     * @type {any}
     * @memberof PoolSnapshot
     */
    'vote_counts': any;
    /**
     * 
     * @type {number}
     * @memberof PoolSnapshot
     */
    'total_votes': number;
    /**
     * 
     * @type {string}
     * @memberof PoolSnapshot
     */
    'created_at': string;
}
/**
 * Serializer for updating pools (superadmin only).
 * @export
 * @interface PoolUpdate
 */
export interface PoolUpdate {
    /**
     * 
     * @type {string}
     * @memberof PoolUpdate
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PoolUpdate
     */
    'description'?: string;
    /**
     * Betting automatically closes at this time (optional - leave empty for manual close only)
     * @type {string}
     * @memberof PoolUpdate
     */
    'expiry_datetime'?: string | null;
}
/**
 * Serializer for revealing the result.
 * @export
 * @interface Reveal
 */
export interface Reveal {
    /**
     * 
     * @type {string}
     * @memberof Reveal
     */
    'result': string;
    /**
     * Must be true to confirm reveal
     * @type {boolean}
     * @memberof Reveal
     */
    'confirm': boolean;
}
/**
 * * `open` - Betting Open * `closed` - Betting Closed * `revealed` - Result Revealed
 * @export
 * @enum {string}
 */

export const StatusEnum = {
    Open: 'open',
    Closed: 'closed',
    Revealed: 'revealed'
} as const;

export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];


/**
 * Serializer for user profile data.
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     * 
     * @type {number}
     * @memberof UserProfile
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    'email': string;
}
/**
 * Serializer for vote data (post-reveal stats).
 * @export
 * @interface Vote
 */
export interface Vote {
    /**
     * 
     * @type {string}
     * @memberof Vote
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Vote
     */
    'user_email': string;
    /**
     * 
     * @type {string}
     * @memberof Vote
     */
    'user_name': string;
    /**
     * 
     * @type {string}
     * @memberof Vote
     */
    'choice': string;
    /**
     * 
     * @type {string}
     * @memberof Vote
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Vote
     */
    'updated_at': string;
}
/**
 * Serializer for casting a vote.
 * @export
 * @interface VoteCreate
 */
export interface VoteCreate {
    /**
     * 
     * @type {string}
     * @memberof VoteCreate
     */
    'choice': string;
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current user\'s profile.  Returns user info including superadmin status derived from SUPERADMIN_EMAILS environment variable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authProfileRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/profile/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current user\'s profile.  Returns user info including superadmin status derived from SUPERADMIN_EMAILS environment variable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authProfileRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authProfileRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authProfileRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Get current user\'s profile.  Returns user info including superadmin status derived from SUPERADMIN_EMAILS environment variable.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authProfileRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<UserProfile> {
            return localVarFp.authProfileRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Get current user\'s profile.  Returns user info including superadmin status derived from SUPERADMIN_EMAILS environment variable.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authProfileRetrieve(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authProfileRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CmsApi - axios parameter creator
 * @export
 */
export const CmsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get any CMS page by its path. Supports unlimited nesting.
         * @param {string} path Page path (e.g., \&#39;blog/my-post\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cmsPageTreeByPath: async (path: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'path' is not null or undefined
            assertParamExists('cmsPageTreeByPath', 'path', path)
            const localVarPath = `/api/cms/page-tree/{path}/`
                .replace(`{${"path"}}`, encodeURIComponent(String(path)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the home page (root of the page tree).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cmsPageTreeRoot: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/cms/page-tree/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CmsApi - functional programming interface
 * @export
 */
export const CmsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CmsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get any CMS page by its path. Supports unlimited nesting.
         * @param {string} path Page path (e.g., \&#39;blog/my-post\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cmsPageTreeByPath(path: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTree>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cmsPageTreeByPath(path, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsApi.cmsPageTreeByPath']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the home page (root of the page tree).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cmsPageTreeRoot(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTree>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cmsPageTreeRoot(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CmsApi.cmsPageTreeRoot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CmsApi - factory interface
 * @export
 */
export const CmsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CmsApiFp(configuration)
    return {
        /**
         * Get any CMS page by its path. Supports unlimited nesting.
         * @param {string} path Page path (e.g., \&#39;blog/my-post\&#39;)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cmsPageTreeByPath(path: string, options?: RawAxiosRequestConfig): AxiosPromise<PageTree> {
            return localVarFp.cmsPageTreeByPath(path, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the home page (root of the page tree).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cmsPageTreeRoot(options?: RawAxiosRequestConfig): AxiosPromise<PageTree> {
            return localVarFp.cmsPageTreeRoot(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CmsApi - object-oriented interface
 * @export
 * @class CmsApi
 * @extends {BaseAPI}
 */
export class CmsApi extends BaseAPI {
    /**
     * Get any CMS page by its path. Supports unlimited nesting.
     * @param {string} path Page path (e.g., \&#39;blog/my-post\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CmsApi
     */
    public cmsPageTreeByPath(path: string, options?: RawAxiosRequestConfig) {
        return CmsApiFp(this.configuration).cmsPageTreeByPath(path, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the home page (root of the page tree).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CmsApi
     */
    public cmsPageTreeRoot(options?: RawAxiosRequestConfig) {
        return CmsApiFp(this.configuration).cmsPageTreeRoot(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommentsApi - axios parameter creator
 * @export
 */
export const CommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {CommentCreate} commentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsCreate: async (commentCreate: CommentCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commentCreate' is not null or undefined
            assertParamExists('commentsCreate', 'commentCreate', commentCreate)
            const localVarPath = `/api/comments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {string} id A UUID string identifying this comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commentsDestroy', 'id', id)
            const localVarPath = `/api/comments/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/comments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {string} id A UUID string identifying this comment.
         * @param {PatchedCommentUpdate} [patchedCommentUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsPartialUpdate: async (id: string, patchedCommentUpdate?: PatchedCommentUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commentsPartialUpdate', 'id', id)
            const localVarPath = `/api/comments/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCommentUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {string} id A UUID string identifying this comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commentsRetrieve', 'id', id)
            const localVarPath = `/api/comments/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle upvote on a comment.
         * @param {string} id A UUID string identifying this comment.
         * @param {Comment} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsUpvoteCreate: async (id: string, comment?: Comment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commentsUpvoteCreate', 'id', id)
            const localVarPath = `/api/comments/{id}/upvote/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(comment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle upvote on a comment.
         * @param {string} id A UUID string identifying this comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsUpvoteDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('commentsUpvoteDestroy', 'id', id)
            const localVarPath = `/api/comments/{id}/upvote/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentsApi - functional programming interface
 * @export
 */
export const CommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {CommentCreate} commentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsCreate(commentCreate: CommentCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsCreate(commentCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {string} id A UUID string identifying this comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Comment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {string} id A UUID string identifying this comment.
         * @param {PatchedCommentUpdate} [patchedCommentUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsPartialUpdate(id: string, patchedCommentUpdate?: PatchedCommentUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentUpdate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsPartialUpdate(id, patchedCommentUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {string} id A UUID string identifying this comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle upvote on a comment.
         * @param {string} id A UUID string identifying this comment.
         * @param {Comment} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsUpvoteCreate(id: string, comment?: Comment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsUpvoteCreate(id, comment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsUpvoteCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle upvote on a comment.
         * @param {string} id A UUID string identifying this comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commentsUpvoteDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commentsUpvoteDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommentsApi.commentsUpvoteDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommentsApi - factory interface
 * @export
 */
export const CommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommentsApiFp(configuration)
    return {
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {CommentCreate} commentCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsCreate(commentCreate: CommentCreate, options?: RawAxiosRequestConfig): AxiosPromise<CommentCreate> {
            return localVarFp.commentsCreate(commentCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {string} id A UUID string identifying this comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.commentsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsList(options?: RawAxiosRequestConfig): AxiosPromise<Array<Comment>> {
            return localVarFp.commentsList(options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {string} id A UUID string identifying this comment.
         * @param {PatchedCommentUpdate} [patchedCommentUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsPartialUpdate(id: string, patchedCommentUpdate?: PatchedCommentUpdate, options?: RawAxiosRequestConfig): AxiosPromise<CommentUpdate> {
            return localVarFp.commentsPartialUpdate(id, patchedCommentUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
         * @param {string} id A UUID string identifying this comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Comment> {
            return localVarFp.commentsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle upvote on a comment.
         * @param {string} id A UUID string identifying this comment.
         * @param {Comment} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsUpvoteCreate(id: string, comment?: Comment, options?: RawAxiosRequestConfig): AxiosPromise<Comment> {
            return localVarFp.commentsUpvoteCreate(id, comment, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle upvote on a comment.
         * @param {string} id A UUID string identifying this comment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commentsUpvoteDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Comment> {
            return localVarFp.commentsUpvoteDestroy(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommentsApi - object-oriented interface
 * @export
 * @class CommentsApi
 * @extends {BaseAPI}
 */
export class CommentsApi extends BaseAPI {
    /**
     * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
     * @param {CommentCreate} commentCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsCreate(commentCreate: CommentCreate, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsCreate(commentCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
     * @param {string} id A UUID string identifying this comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsList(options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
     * @param {string} id A UUID string identifying this comment.
     * @param {PatchedCommentUpdate} [patchedCommentUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsPartialUpdate(id: string, patchedCommentUpdate?: PatchedCommentUpdate, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsPartialUpdate(id, patchedCommentUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for thread comments.  - list/create: authenticated users - partial_update/destroy: comment owner or superadmin - upvote: authenticated users
     * @param {string} id A UUID string identifying this comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle upvote on a comment.
     * @param {string} id A UUID string identifying this comment.
     * @param {Comment} [comment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsUpvoteCreate(id: string, comment?: Comment, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsUpvoteCreate(id, comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle upvote on a comment.
     * @param {string} id A UUID string identifying this comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public commentsUpvoteDestroy(id: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).commentsUpvoteDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeedbackApi - axios parameter creator
 * @export
 */
export const FeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Submit feedback with optional media attachments.  Sends an email to all configured SUPERADMIN_EMAILS with the message and any attached images/videos. Reply-to is set to the submitting user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackCreate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/feedback/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeedbackApi - functional programming interface
 * @export
 */
export const FeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * Submit feedback with optional media attachments.  Sends an email to all configured SUPERADMIN_EMAILS with the message and any attached images/videos. Reply-to is set to the submitting user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feedbackCreate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feedbackCreate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeedbackApi.feedbackCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeedbackApi - factory interface
 * @export
 */
export const FeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeedbackApiFp(configuration)
    return {
        /**
         * Submit feedback with optional media attachments.  Sends an email to all configured SUPERADMIN_EMAILS with the message and any attached images/videos. Reply-to is set to the submitting user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackCreate(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.feedbackCreate(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeedbackApi - object-oriented interface
 * @export
 * @class FeedbackApi
 * @extends {BaseAPI}
 */
export class FeedbackApi extends BaseAPI {
    /**
     * Submit feedback with optional media attachments.  Sends an email to all configured SUPERADMIN_EMAILS with the message and any attached images/videos. Reply-to is set to the submitting user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeedbackApi
     */
    public feedbackCreate(options?: RawAxiosRequestConfig) {
        return FeedbackApiFp(this.configuration).feedbackCreate(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthCheck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<HealthCheck> {
            return localVarFp.healthRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public healthRetrieve(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).healthRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PoolBetApi - axios parameter creator
 * @export
 */
export const PoolBetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Manually close betting on this pool.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsCloseCreate: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsCloseCreate', 'slug', slug)
            const localVarPath = `/api/pool-bet/pools/{slug}/close/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {PoolCreate} poolCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsCreate: async (poolCreate: PoolCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'poolCreate' is not null or undefined
            assertParamExists('poolBetPoolsCreate', 'poolCreate', poolCreate)
            const localVarPath = `/api/pool-bet/pools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsDestroy: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsDestroy', 'slug', slug)
            const localVarPath = `/api/pool-bet/pools/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pool-bet/pools/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current user\'s vote for this pool.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsMyVoteRetrieve: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsMyVoteRetrieve', 'slug', slug)
            const localVarPath = `/api/pool-bet/pools/{slug}/my_vote/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {PatchedPoolUpdate} [patchedPoolUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsPartialUpdate: async (slug: string, patchedPoolUpdate?: PatchedPoolUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsPartialUpdate', 'slug', slug)
            const localVarPath = `/api/pool-bet/pools/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedPoolUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reopen betting (in case of accidental close or reveal).
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsReopenCreate: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsReopenCreate', 'slug', slug)
            const localVarPath = `/api/pool-bet/pools/{slug}/reopen/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsRetrieve: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsRetrieve', 'slug', slug)
            const localVarPath = `/api/pool-bet/pools/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reveal the result of this pool.
         * @param {string} slug 
         * @param {Reveal} reveal 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsRevealCreate: async (slug: string, reveal: Reveal, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsRevealCreate', 'slug', slug)
            // verify required parameter 'reveal' is not null or undefined
            assertParamExists('poolBetPoolsRevealCreate', 'reveal', reveal)
            const localVarPath = `/api/pool-bet/pools/{slug}/reveal/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reveal, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return all vote-count snapshots for this pool, oldest first.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsSnapshotsList: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsSnapshotsList', 'slug', slug)
            const localVarPath = `/api/pool-bet/pools/{slug}/snapshots/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {PoolUpdate} poolUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsUpdate: async (slug: string, poolUpdate: PoolUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsUpdate', 'slug', slug)
            // verify required parameter 'poolUpdate' is not null or undefined
            assertParamExists('poolBetPoolsUpdate', 'poolUpdate', poolUpdate)
            const localVarPath = `/api/pool-bet/pools/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(poolUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cast, update, or cancel a vote on this pool.
         * @param {string} slug 
         * @param {VoteCreate} voteCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsVoteCreate: async (slug: string, voteCreate: VoteCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsVoteCreate', 'slug', slug)
            // verify required parameter 'voteCreate' is not null or undefined
            assertParamExists('poolBetPoolsVoteCreate', 'voteCreate', voteCreate)
            const localVarPath = `/api/pool-bet/pools/{slug}/vote/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voteCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cast, update, or cancel a vote on this pool.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsVoteDestroy: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsVoteDestroy', 'slug', slug)
            const localVarPath = `/api/pool-bet/pools/{slug}/vote/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all votes for this pool. Only available after result is revealed.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsVotesList: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('poolBetPoolsVotesList', 'slug', slug)
            const localVarPath = `/api/pool-bet/pools/{slug}/votes/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PoolBetApi - functional programming interface
 * @export
 */
export const PoolBetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PoolBetApiAxiosParamCreator(configuration)
    return {
        /**
         * Manually close betting on this pool.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsCloseCreate(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsCloseCreate(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsCloseCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {PoolCreate} poolCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsCreate(poolCreate: PoolCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsCreate(poolCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsDestroy(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsDestroy(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PoolList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the current user\'s vote for this pool.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsMyVoteRetrieve(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vote>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsMyVoteRetrieve(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsMyVoteRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {PatchedPoolUpdate} [patchedPoolUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsPartialUpdate(slug: string, patchedPoolUpdate?: PatchedPoolUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolUpdate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsPartialUpdate(slug, patchedPoolUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reopen betting (in case of accidental close or reveal).
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsReopenCreate(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsReopenCreate(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsReopenCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsRetrieve(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsRetrieve(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reveal the result of this pool.
         * @param {string} slug 
         * @param {Reveal} reveal 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsRevealCreate(slug: string, reveal: Reveal, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsRevealCreate(slug, reveal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsRevealCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return all vote-count snapshots for this pool, oldest first.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsSnapshotsList(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PoolSnapshot>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsSnapshotsList(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsSnapshotsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {PoolUpdate} poolUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsUpdate(slug: string, poolUpdate: PoolUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolUpdate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsUpdate(slug, poolUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cast, update, or cancel a vote on this pool.
         * @param {string} slug 
         * @param {VoteCreate} voteCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsVoteCreate(slug: string, voteCreate: VoteCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsVoteCreate(slug, voteCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsVoteCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cast, update, or cancel a vote on this pool.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsVoteDestroy(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PoolDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsVoteDestroy(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsVoteDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all votes for this pool. Only available after result is revealed.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async poolBetPoolsVotesList(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Vote>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.poolBetPoolsVotesList(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PoolBetApi.poolBetPoolsVotesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PoolBetApi - factory interface
 * @export
 */
export const PoolBetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PoolBetApiFp(configuration)
    return {
        /**
         * Manually close betting on this pool.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsCloseCreate(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<PoolDetail> {
            return localVarFp.poolBetPoolsCloseCreate(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {PoolCreate} poolCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsCreate(poolCreate: PoolCreate, options?: RawAxiosRequestConfig): AxiosPromise<PoolCreate> {
            return localVarFp.poolBetPoolsCreate(poolCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsDestroy(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.poolBetPoolsDestroy(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsList(options?: RawAxiosRequestConfig): AxiosPromise<Array<PoolList>> {
            return localVarFp.poolBetPoolsList(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current user\'s vote for this pool.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsMyVoteRetrieve(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<Vote> {
            return localVarFp.poolBetPoolsMyVoteRetrieve(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {PatchedPoolUpdate} [patchedPoolUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsPartialUpdate(slug: string, patchedPoolUpdate?: PatchedPoolUpdate, options?: RawAxiosRequestConfig): AxiosPromise<PoolUpdate> {
            return localVarFp.poolBetPoolsPartialUpdate(slug, patchedPoolUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Reopen betting (in case of accidental close or reveal).
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsReopenCreate(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<PoolDetail> {
            return localVarFp.poolBetPoolsReopenCreate(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsRetrieve(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<PoolDetail> {
            return localVarFp.poolBetPoolsRetrieve(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Reveal the result of this pool.
         * @param {string} slug 
         * @param {Reveal} reveal 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsRevealCreate(slug: string, reveal: Reveal, options?: RawAxiosRequestConfig): AxiosPromise<PoolDetail> {
            return localVarFp.poolBetPoolsRevealCreate(slug, reveal, options).then((request) => request(axios, basePath));
        },
        /**
         * Return all vote-count snapshots for this pool, oldest first.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsSnapshotsList(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PoolSnapshot>> {
            return localVarFp.poolBetPoolsSnapshotsList(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
         * @param {string} slug 
         * @param {PoolUpdate} poolUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsUpdate(slug: string, poolUpdate: PoolUpdate, options?: RawAxiosRequestConfig): AxiosPromise<PoolUpdate> {
            return localVarFp.poolBetPoolsUpdate(slug, poolUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * Cast, update, or cancel a vote on this pool.
         * @param {string} slug 
         * @param {VoteCreate} voteCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsVoteCreate(slug: string, voteCreate: VoteCreate, options?: RawAxiosRequestConfig): AxiosPromise<PoolDetail> {
            return localVarFp.poolBetPoolsVoteCreate(slug, voteCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Cast, update, or cancel a vote on this pool.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsVoteDestroy(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<PoolDetail> {
            return localVarFp.poolBetPoolsVoteDestroy(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * List all votes for this pool. Only available after result is revealed.
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        poolBetPoolsVotesList(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Vote>> {
            return localVarFp.poolBetPoolsVotesList(slug, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PoolBetApi - object-oriented interface
 * @export
 * @class PoolBetApi
 * @extends {BaseAPI}
 */
export class PoolBetApi extends BaseAPI {
    /**
     * Manually close betting on this pool.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsCloseCreate(slug: string, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsCloseCreate(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
     * @param {PoolCreate} poolCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsCreate(poolCreate: PoolCreate, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsCreate(poolCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsDestroy(slug: string, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsDestroy(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsList(options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current user\'s vote for this pool.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsMyVoteRetrieve(slug: string, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsMyVoteRetrieve(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
     * @param {string} slug 
     * @param {PatchedPoolUpdate} [patchedPoolUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsPartialUpdate(slug: string, patchedPoolUpdate?: PatchedPoolUpdate, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsPartialUpdate(slug, patchedPoolUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reopen betting (in case of accidental close or reveal).
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsReopenCreate(slug: string, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsReopenCreate(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsRetrieve(slug: string, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsRetrieve(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reveal the result of this pool.
     * @param {string} slug 
     * @param {Reveal} reveal 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsRevealCreate(slug: string, reveal: Reveal, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsRevealCreate(slug, reveal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return all vote-count snapshots for this pool, oldest first.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsSnapshotsList(slug: string, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsSnapshotsList(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ViewSet for betting pools.  - List/Retrieve: All authenticated users - Create/Update/Delete: Superadmins only
     * @param {string} slug 
     * @param {PoolUpdate} poolUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsUpdate(slug: string, poolUpdate: PoolUpdate, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsUpdate(slug, poolUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cast, update, or cancel a vote on this pool.
     * @param {string} slug 
     * @param {VoteCreate} voteCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsVoteCreate(slug: string, voteCreate: VoteCreate, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsVoteCreate(slug, voteCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cast, update, or cancel a vote on this pool.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsVoteDestroy(slug: string, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsVoteDestroy(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all votes for this pool. Only available after result is revealed.
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoolBetApi
     */
    public poolBetPoolsVotesList(slug: string, options?: RawAxiosRequestConfig) {
        return PoolBetApiFp(this.configuration).poolBetPoolsVotesList(slug, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchemaApi - axios parameter creator
 * @export
 */
export const SchemaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {SchemaRetrieveFormatEnum} [format] 
         * @param {SchemaRetrieveLangEnum} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemaRetrieve: async (format?: SchemaRetrieveFormatEnum, lang?: SchemaRetrieveLangEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/schema/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchemaApi - functional programming interface
 * @export
 */
export const SchemaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchemaApiAxiosParamCreator(configuration)
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {SchemaRetrieveFormatEnum} [format] 
         * @param {SchemaRetrieveLangEnum} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schemaRetrieve(format?: SchemaRetrieveFormatEnum, lang?: SchemaRetrieveLangEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schemaRetrieve(format, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchemaApi.schemaRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchemaApi - factory interface
 * @export
 */
export const SchemaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchemaApiFp(configuration)
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {SchemaRetrieveFormatEnum} [format] 
         * @param {SchemaRetrieveLangEnum} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemaRetrieve(format?: SchemaRetrieveFormatEnum, lang?: SchemaRetrieveLangEnum, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.schemaRetrieve(format, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchemaApi - object-oriented interface
 * @export
 * @class SchemaApi
 * @extends {BaseAPI}
 */
export class SchemaApi extends BaseAPI {
    /**
     * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     * @param {SchemaRetrieveFormatEnum} [format] 
     * @param {SchemaRetrieveLangEnum} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaApi
     */
    public schemaRetrieve(format?: SchemaRetrieveFormatEnum, lang?: SchemaRetrieveLangEnum, options?: RawAxiosRequestConfig) {
        return SchemaApiFp(this.configuration).schemaRetrieve(format, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const SchemaRetrieveFormatEnum = {
    Json: 'json',
    Yaml: 'yaml'
} as const;
export type SchemaRetrieveFormatEnum = typeof SchemaRetrieveFormatEnum[keyof typeof SchemaRetrieveFormatEnum];
/**
 * @export
 */
export const SchemaRetrieveLangEnum = {
    Af: 'af',
    Ar: 'ar',
    ArDz: 'ar-dz',
    Ast: 'ast',
    Az: 'az',
    Be: 'be',
    Bg: 'bg',
    Bn: 'bn',
    Br: 'br',
    Bs: 'bs',
    Ca: 'ca',
    Ckb: 'ckb',
    Cs: 'cs',
    Cy: 'cy',
    Da: 'da',
    De: 'de',
    Dsb: 'dsb',
    El: 'el',
    En: 'en',
    EnAu: 'en-au',
    EnGb: 'en-gb',
    Eo: 'eo',
    Es: 'es',
    EsAr: 'es-ar',
    EsCo: 'es-co',
    EsMx: 'es-mx',
    EsNi: 'es-ni',
    EsVe: 'es-ve',
    Et: 'et',
    Eu: 'eu',
    Fa: 'fa',
    Fi: 'fi',
    Fr: 'fr',
    Fy: 'fy',
    Ga: 'ga',
    Gd: 'gd',
    Gl: 'gl',
    He: 'he',
    Hi: 'hi',
    Hr: 'hr',
    Hsb: 'hsb',
    Hu: 'hu',
    Hy: 'hy',
    Ia: 'ia',
    Id: 'id',
    Ig: 'ig',
    Io: 'io',
    Is: 'is',
    It: 'it',
    Ja: 'ja',
    Ka: 'ka',
    Kab: 'kab',
    Kk: 'kk',
    Km: 'km',
    Kn: 'kn',
    Ko: 'ko',
    Ky: 'ky',
    Lb: 'lb',
    Lt: 'lt',
    Lv: 'lv',
    Mk: 'mk',
    Ml: 'ml',
    Mn: 'mn',
    Mr: 'mr',
    Ms: 'ms',
    My: 'my',
    Nb: 'nb',
    Ne: 'ne',
    Nl: 'nl',
    Nn: 'nn',
    Os: 'os',
    Pa: 'pa',
    Pl: 'pl',
    Pt: 'pt',
    PtBr: 'pt-br',
    Ro: 'ro',
    Ru: 'ru',
    Sk: 'sk',
    Sl: 'sl',
    Sq: 'sq',
    Sr: 'sr',
    SrLatn: 'sr-latn',
    Sv: 'sv',
    Sw: 'sw',
    Ta: 'ta',
    Te: 'te',
    Tg: 'tg',
    Th: 'th',
    Tk: 'tk',
    Tr: 'tr',
    Tt: 'tt',
    Udm: 'udm',
    Ug: 'ug',
    Uk: 'uk',
    Ur: 'ur',
    Uz: 'uz',
    Vi: 'vi',
    ZhHans: 'zh-hans',
    ZhHant: 'zh-hant'
} as const;
export type SchemaRetrieveLangEnum = typeof SchemaRetrieveLangEnum[keyof typeof SchemaRetrieveLangEnum];


